import styles from './ProcessingScreenLoaderCircle.module.scss';

export type ProcessingScreenLoaderCircleProps = {
  value: number;
};

const ProcessingScreenLoaderCircle = ({ value }: ProcessingScreenLoaderCircleProps) => (
  <svg viewBox="0 0 38 38" className={styles.circle}>
    <circle className="donut-hole" cx="50%" cy="50%" r="15.91549430918954" fill="transparent"></circle>

    <circle
      className="donut-ring"
      cx="50%"
      cy="50%"
      r="15.91549430918954"
      fill="transparent"
      stroke="url(#paint0_linear)"
      strokeWidth="3"
    ></circle>

    <circle
      className="donut-segment"
      cx="50%"
      cy="50%"
      r="15.91549430918954"
      fill="transparent"
      stroke="#D2D1F9"
      opacity="1"
      strokeWidth="3"
      strokeDasharray={`${100 - value} ${value}`}
    ></circle>

    <defs>
      <linearGradient id="paint0_linear" x1="45" y2="-9.5" x2="53.1842" y1="40" gradientUnits="userSpaceOnUse">
        <stop offset="4.19%" stopColor="#3639A2" />

        <stop offset="49.79%" stopColor="#6D4BCD" />

        <stop offset="81.72%" stopColor="#9D5BE9" />
      </linearGradient>
    </defs>
  </svg>
);

export default ProcessingScreenLoaderCircle;
